import React, { useState } from 'react';
import { BiPlay } from 'react-icons/bi'
import { AnimatePresence, motion } from 'framer-motion'

import {GetPlayer} from '../../../hoc/Layout/Layout'


const varinatsL = {
    init: {
        x: '-30%',
        opacity: .2,
        scale: 1,
    },
    show: {
        x: '0',
        scale: 1,
        opacity: 1,
        transition: {
            duration: .2,
            type: "tween"
        }
    }
}
const varinatsR = {
    init: {
        x: '+30%',
        opacity: .2
    },
    show: {
        x: '0',
        opacity: 1,
        transition: {
            duration: .2,
            type: "tween"

        }
    }
}

const FeaturedItemMain = (props) => {
    const [ items, setItems ] = useState(props.item) 
    const [ page, setPage ] = useState(0)

    const { setPid, setTracks } = GetPlayer()

    const renderItems = (items, offset, limit) => {
        return items.slice(offset, limit).map((item, key) => (
            <motion.div 
            initial={{scale : 1}}
            whileHover={{
                scale: .98,
                transition: {
                    duration: .2
                }
            }}
            key={key} className={`featured__item-main featured__item-main--${key}`}

            onClick={(e) =>  {
                // setTracks(null);
                setPid(item.id)}}
            style={{
                backgroundImage: `url('${item.album.images[0].url}')`
            }}
        >
            <h3 className="preview"><BiPlay size="45" /></h3>
            <div className="text-center">
                <h2>{item.name}</h2>
            </div>
            <div>
                <h3>Artist</h3>
                <p>{item.artists[0].name}</p>
            </div>
        </motion.div>
        ))
    }

    return (
     <>
 <div className="horizontal">
           <AnimatePresence>
            {
                page == 0 ?
                    <motion.div 
                        key={1}
                    variants={varinatsL}
                    initial='init'
                    animate='show'
                    exit='init'
                    className="f_display">
                        {renderItems(items, 0, 5)}
                    </motion.div>
                :
                    <motion.div 
                        key={2}
                        variants={varinatsR}
                    initial='init'
                    animate='show'
                    exit='init'
                    className="f_display">
                        {renderItems(items, 5, 10)}
                    </motion.div>}
       </AnimatePresence>
      </div>
      <div className="featured__control">
          <button className={`featured__page-button ${page == 0 ? 'featured__page-button--active' : null }`} onClick={() => setPage(0)}></button>
          <button className={`featured__page-button ${page == 1 ? 'featured__page-button--active' : null }`} onClick={() => setPage(1)}></button>
      </div>
     </>
        );
}

export default FeaturedItemMain;
